// extracted by mini-css-extract-plugin
export var activeFilterButton = "_pm-c";
export var backButton = "_pm-4";
export var backIcon = "_pm-5";
export var chevronShortcut = "_pm-6";
export var container = "_pm-1";
export var editor = "_pm-8";
export var editorWrapper = "_pm-7";
export var prefix = "_pm-2";
export var searchIcon = "_pm-3";
export var suffix = "_pm-9";
export var suffixContent = "_pm-a";
export var suffixText = "_pm-b";
export var wrapper = "_pm-0";